import { h } from '@stencil/core';

const UploadIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 3V7V11M10 3L6 7M10 3L14 7" stroke="#46435B" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M4 11V14C4 15.6569 5.34315 17 7 17H13C14.6569 17 16 15.6569 16 14V11" stroke="#46435B" stroke-linecap="round" />
    </svg>
  );
};

export default UploadIcon;
